// import { useInfiniteQuery } from "@tanstack/react-query";
// import { GetCustomerTransactions, type CustomerTransactionParams } from "./api.js";

// // ============================================
// // ✅ تراکنش‌ها با Infinite Scroll
// // ============================================
// export const useGetCustomerTransactionsInfinite = ({
//     size = 10,
//     sortField = "transactionDate",
//     sortDirection = "DESC",
// }: {
//     size?: number;
//     sortField?: string;
//     sortDirection?: "ASC" | "DESC" | "ACS" | "DESC";
// } = {}) => {
//     return useInfiniteQuery({
//         queryKey: ["CustomerTransactionsInfinite", { size, sortField, sortDirection }],
//         queryFn: ({ pageParam = 0 }) =>
//             GetCustomerTransactions({
//                 page: pageParam,
//                 size,
//                 sortField,
//                 sortDirection,
//             }),
//         initialPageParam: 0,
//         getNextPageParam: (lastPage, allPages) => {
//             const totalCount = lastPage?.count ?? 0;
//             const loaded = allPages.reduce(
//                 (sum, p) => sum + (p?.payload?.length ?? 0),
//                 0
//             );
//             if (loaded < totalCount) {
//                 return allPages.length; // page بعدی
//             }
//             return undefined;
//         },
//         refetchOnWindowFocus: false,
//     });
// };

import { useInfiniteQuery } from "@tanstack/react-query";
import {
    GetCustomerTransactions,
    GetBlockedTransactions,
    type CustomerTransactionParams,
} from "./api.js";

// ============================================
// ✅ نوع کیف پول
// ============================================
export type WalletKind = "free" | "blocked";

interface UseGetCustomerTransactionsInfiniteParams {
    wallet?: WalletKind;
    size?: number;
    sortField?: string;
    sortDirection?: "ASC" | "DESC";
}

// ============================================
// ✅ تراکنش‌ها با Infinite Scroll (آزاد / بلاک‌شده)
// ============================================
export const useGetCustomerTransactionsInfinite = ({
    wallet = "free",
    size,
    sortField,
    sortDirection,
}: UseGetCustomerTransactionsInfiniteParams = {}) => {
    const isBlocked = wallet === "blocked";

    // پیش‌فرض‌ها بر اساس نوع کیف پول
    const finalSize = size ?? (isBlocked ? 25 : 10);
    const finalSortField = sortField ?? (isBlocked ? "id" : "transactionDate");
    const finalSortDirection =
        sortDirection ?? (isBlocked ? "ASC" : "DESC");

    return useInfiniteQuery({
        queryKey: [
            "CustomerTransactionsInfinite",
            wallet,
            { size: finalSize, sortField: finalSortField, sortDirection: finalSortDirection },
        ],
        queryFn: ({ pageParam = 0 }) => {
            const params: CustomerTransactionParams = {
                page: pageParam,
                size: finalSize,
                sortField: finalSortField,
                sortDirection: finalSortDirection,
            };
            return isBlocked
                ? GetBlockedTransactions(params)
                : GetCustomerTransactions(params);
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages) => {
            const totalCount = lastPage?.count ?? 0;
            const loaded = allPages.reduce(
                (sum, p) => sum + (p?.payload?.length ?? 0),
                0
            );
            if (loaded < totalCount) {
                return allPages.length; // page بعدی
            }
            return undefined;
        },
        refetchOnWindowFocus: false,
        refetchOnMount: "always", // ✅ هر بار mount شدن، دوباره fetch کن
        staleTime: 0,             // ✅ داده‌ها همیشه stale در نظر گرفته بشن
        gcTime: 0,
    });
};